"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _checkbox = _interopRequireDefault(require("../checkbox"));
var _radio = _interopRequireDefault(require("../radio"));
var _tooltip = _interopRequireDefault(require("../tooltip"));
var _ahooks = require("ahooks");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../_util/utils");
var _selectionModal = _interopRequireDefault(require("./selectionModal"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function SelectionHOC(props) {
  const {
    children,
    dataSource = [],
    rowKey,
    selection
  } = props;

  //主要是将dataSource平铺
  const floorDataSource = (0, _react.useMemo)(() => (0, _utils.treeToArr)(dataSource, rowKey), [dataSource]);
  const currentDataSourceKeys = (0, _react.useMemo)(() => {
    var _floorDataSource$filt;
    return (floorDataSource === null || floorDataSource === void 0 || (_floorDataSource$filt = floorDataSource.filter(d => {
      var _selection$getCheckbo;
      return (selection === null || selection === void 0 || (_selection$getCheckbo = selection.getCheckboxProps) === null || _selection$getCheckbo === void 0 || (_selection$getCheckbo = _selection$getCheckbo.call(selection, d)) === null || _selection$getCheckbo === void 0 ? void 0 : _selection$getCheckbo.disabled) !== true;
    })) === null || _floorDataSource$filt === void 0 ? void 0 : _floorDataSource$filt.map(d => d[rowKey])) || [];
  }, [floorDataSource]);
  const [keys = [], onChange] = (0, _ahooks.useControllableValue)(selection, {
    defaultValue: [],
    defaultValuePropName: 'defaultSelectedRowKeys',
    valuePropName: 'selectedRowKeys',
    trigger: 'onChange'
  });
  const initalSelectedRows = keys => keys.map(k => {
    return [...(floorDataSource || [])].find(d => (d === null || d === void 0 ? void 0 : d[rowKey]) === k);
  });
  const [selectedRows, setSelectedRows] = (0, _react.useState)(initalSelectedRows(keys));
  const getselectedRows = keys => keys.map(k => {
    return [...(floorDataSource || []), ...(selectedRows || [])].find(d => (d === null || d === void 0 ? void 0 : d[rowKey]) === k);
  });
  (0, _ahooks.useUpdateEffect)(() => {
    setSelectedRows(getselectedRows(keys));
  }, [JSON.stringify(keys)]);
  const [showTipKey, setShowTipKey] = (0, _react.useState)();
  const rowSelection = (0, _react.useMemo)(() => {
    if (!selection) {
      return undefined;
    }
    const isAllSelected = !!(currentDataSourceKeys !== null && currentDataSourceKeys !== void 0 && currentDataSourceKeys.length) && currentDataSourceKeys.every(k => keys.includes(k));
    const isNoneSelected = currentDataSourceKeys.every(k => !keys.includes(k));
    return {
      fixed: 'left',
      columnWidth: 48,
      columnTitle: (selection === null || selection === void 0 ? void 0 : selection.type) === 'radio' || selection.checkAll === false ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_checkbox.default, {
        size: "s",
        checked: isAllSelected,
        disabled: !(currentDataSourceKeys !== null && currentDataSourceKeys !== void 0 && currentDataSourceKeys.length),
        onChange: v => {
          if (v) {
            const notChosenKeys = currentDataSourceKeys.filter(k => !keys.includes(k));
            const _keys = [...keys, ...notChosenKeys];
            onChange(_keys, getselectedRows(_keys));
          } else {
            const _keys = keys.filter(k => !currentDataSourceKeys.includes(k));
            onChange(_keys, getselectedRows(_keys));
          }
        },
        indeterminate: !isAllSelected && !isNoneSelected
      }),
      renderCell: (checked, record, index, originNode) => {
        var _selection$getCheckbo2;
        const currentKey = record[rowKey];
        const {
          tooltip,
          ...props
        } = (selection === null || selection === void 0 || (_selection$getCheckbo2 = selection.getCheckboxProps) === null || _selection$getCheckbo2 === void 0 ? void 0 : _selection$getCheckbo2.call(selection, record)) || {};
        const dom = (selection === null || selection === void 0 ? void 0 : selection.type) === 'radio' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_radio.default, {
          size: "s",
          checked: keys.includes(currentKey),
          onChange: v => {
            if (v) {
              const _keys = [currentKey];
              onChange(_keys, getselectedRows(_keys));
            } else {
              onChange([], []);
            }
          },
          ...props
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_checkbox.default, {
          size: "s",
          checked: keys.includes(currentKey),
          onChange: v => {
            if (v) {
              const _keys = [...keys, currentKey];
              onChange(_keys, getselectedRows(_keys));
            } else {
              const _keys = keys.filter(k => k !== currentKey);
              onChange(_keys, getselectedRows(_keys));
            }
          },
          ...props
        });
        if (tooltip) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_tooltip.default, {
            open: currentKey === showTipKey
            //  getPopupContainer={(t) => t}
            ,
            ...tooltip,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              onPointerEnter: e => {
                e.stopPropagation();
                if (!selection.rowClick) {
                  setShowTipKey(currentKey);
                }
              },
              onPointerLeave: e => {
                e.stopPropagation();
                if (!selection.rowClick) {
                  setShowTipKey(undefined);
                }
              },
              children: dom
            })
          });
        }
        return dom;
      }
    };
  }, [selection, keys, currentDataSourceKeys, showTipKey]);
  const operationRender = (0, _react.useMemo)(() => {
    var _selection$operation;
    return selection === null || selection === void 0 || (_selection$operation = selection.operation) === null || _selection$operation === void 0 ? void 0 : _selection$operation.call(selection, keys, selectedRows, onChange);
  }, [keys, selectedRows]);
  const otherOperation = (0, _react.useMemo)(() => {
    var _selection$otherOpera;
    return selection === null || selection === void 0 || (_selection$otherOpera = selection.otherOperation) === null || _selection$otherOpera === void 0 ? void 0 : _selection$otherOpera.call(selection, keys, selectedRows, onChange);
  }, [keys, selectedRows]);
  // ---End---

  //如果有rowClick，增加行点击，并且如果有tooltip，增加行展示
  const onRow = (0, _react.useMemo)(() => {
    if (selection !== null && selection !== void 0 && selection.rowClick) {
      return (record, index) => {
        var _children$props$onRow, _children$props, _selection$getCheckbo3;
        const onPropsRow = (_children$props$onRow = (_children$props = children.props).onRow) === null || _children$props$onRow === void 0 ? void 0 : _children$props$onRow.call(_children$props, record, index);
        const {
          onClick: onPropsClick,
          onPointerEnter: onPropsPointerEnter,
          onPointerLeave: onPropsPointerLeave,
          ...otherOnPropsRow
        } = onPropsRow || {};
        const props = (selection === null || selection === void 0 || (_selection$getCheckbo3 = selection.getCheckboxProps) === null || _selection$getCheckbo3 === void 0 ? void 0 : _selection$getCheckbo3.call(selection, record)) || {};
        const currentKey = record[rowKey];
        return {
          onClick: e => {
            onPropsClick === null || onPropsClick === void 0 || onPropsClick(e);
            if (props.disabled) {
              return;
            }
            const checked = keys.includes(currentKey);
            if ((selection === null || selection === void 0 ? void 0 : selection.type) === 'radio') {
              if (!checked) {
                const _keys = [currentKey];
                onChange(_keys, getselectedRows(_keys));
              }
            } else {
              if (!checked) {
                const _keys = [...keys, currentKey];
                onChange(_keys, getselectedRows(_keys));
              } else {
                const _keys = keys.filter(k => k !== currentKey);
                onChange(_keys, getselectedRows(_keys));
              }
            }
          },
          onPointerEnter: e => {
            onPropsPointerEnter === null || onPropsPointerEnter === void 0 || onPropsPointerEnter(e);
            if (props.tooltip) {
              setShowTipKey(currentKey);
            }
          },
          onPointerLeave: e => {
            onPropsPointerLeave === null || onPropsPointerLeave === void 0 || onPropsPointerLeave(e);
            if (props.tooltip) {
              setShowTipKey(undefined);
            }
          },
          ...otherOnPropsRow
        };
      };
    } else {
      return children.props.onRow;
    }
  }, [selection, children.props.onRow, keys, currentDataSourceKeys]);

  // 增加rowSelectionClick、rowSelectionDisabled类名
  const rowClassName = (0, _react.useMemo)(() => {
    const propsRowClassName = children.props.rowClassName;
    return (record, index, indent) => {
      var _selection$getCheckbo4;
      let mergeRowClassName;
      if (typeof propsRowClassName === 'function') {
        mergeRowClassName = propsRowClassName(record, index, indent);
      } else {
        mergeRowClassName = propsRowClassName;
      }
      const props = selection === null || selection === void 0 || (_selection$getCheckbo4 = selection.getCheckboxProps) === null || _selection$getCheckbo4 === void 0 ? void 0 : _selection$getCheckbo4.call(selection, record);
      return (0, _classnames.default)(mergeRowClassName, {
        rowSelectionClick: selection === null || selection === void 0 ? void 0 : selection.rowClick,
        rowSelectionDisabled: props === null || props === void 0 ? void 0 : props.disabled
      });
    };
  }, [selection, children.props.rowClassName]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/_react.default.cloneElement(children, {
      rowSelection,
      onRow,
      rowClassName
    }), (!!operationRender || !!otherOperation) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_selectionModal.default, {
      operation: operationRender,
      otherOperation: otherOperation,
      selectedRowKeys: keys,
      onChange: onChange
    })]
  });
}
var _default = exports.default = SelectionHOC;